// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  subDomain: 'hubconnectusers',
  apiVersion: '1.0',
  runtime: {
    apiUrl: 'https://hubconnectdev.hubgroup.com/api',
    userManagementApiUrl: 'https://hubconnectdev.hubgroup.com/hubconnectusermanagementapi',
    Url: 'https://hubconnectdev.hubgroup.com',
    apiHost: '/hubconnectusermanagementapi',
    envName: 'dev',
    authClientId: 'JXmT1967dmVCstTRNqi',
    authClientSecret: '7cSTVR1xDUQw9KeldM7HB9hb7',
    authBaseUrl: '/auth',
    samlKeepAliveUrl: 'https://analyticsdev.hubgroup.com/',
    sessionCookie: '_hgladev',
    myAccount: 'https://myaccountdev.hubgroup.com',
    identityUrl: 'https://identitydev.hubgroup.com',
    identityUiUrl: "https://identitydev.hubgroup.com/PasswordManagementUI#",
    locationApiUrl: "https://hubconnectdev.hubgroup.com/hubconnectapi/location",
    orderApiUrl: "https://hubconnectdev.hubgroup.com/hubconnectapi/orders",
    hubconnectApiUrl: "https://hubconnectdev.hubgroup.com/hubconnectapi",
    hubconnectPortalUrl: 'https://hubconnectdev.hubgroup.com'
  },
  max_session_refresh_period_in_seconds: 10,
  showErrors: true
};
